/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt';

import BPButton from '../button';
import Notification from '../notification';
import styles from './styles.css';

const { canSharePage } = require('../../../lib/permissions').default;

export default function SharePageButton() {
  const handleOnCopyClick = () => {
    navigator.clipboard.writeText(window.location.href);
    Notification.success('Link copied to your clipboard.');
  };

  return (
    canSharePage() && (
      <BPButton
        type="button"
        rounded
        secondary
        onClick={handleOnCopyClick}
      >
        <FontAwesomeIcon className={styles.sharePageButtonIcon} icon={faShareAlt} />
          Share Page
      </BPButton>
    )
  );
}
